import BaseBehavior from '../../../framework/base/base';
import { getCookie, setCookie } from '../../../shared/utilities/cookies';
import { hideElement, showElement } from '../../../shared/utilities/show-hide';
import { debounce } from '../../../shared/utilities/debounce';
import pubsub from '../../../shared/utilities/pubsub';
import '../../../shared/utilities/scroll-padding';

const cookieName = 'iit_cookieConsent';

class CookieDisclaimer extends BaseBehavior {
	constructor(element) {
		super(element);
		this.initDomCache();
		this.show();
		this.moveContents();
		this.addEventListeners();
	}

	addEventListeners() {
		this.dom.close &&
			this.addEventListener(this.dom.close, 'click.close', e => {
				e.preventDefault();

				setCookie(cookieName, 'true', new Date().getTime() + 30 * 24 * 60 * 60 * 1000);
				this.hide();

				!this.element.dataset.extendedMobile && this.showLess();
				if (window.Cookiebot) window.Cookiebot.submitCustomConsent(true, true, true);
			});

		this.addEventListener(
			window,
			'resize.cookieDisclaimer',
			debounce(this.moveContents.bind(this), 50)
		);

		if (this.dom.showMore) {
			this.addEventListener(this.dom.showMore, 'click.showMore', e => {
				e.preventDefault();
				this.showMore();
			});
		}
		if (this.dom.showLess) {
			this.addEventListener(this.dom.showLess, 'click.showLess', e => {
				e.preventDefault();
				this.showLess();
			});
		}
		this.subscribe('disclaimer/adjust/height', () => this.moveContents());
	}

	hide() {
		if (this.element.classList.contains('v2-cookie-disclaimer--extended')) {
			hideElement(this.dom.cookie);
		} else {
			hideElement(this.element);
		}
		this.element.classList.add('v2-cookie-disclaimer--accepted');
		this.moveContents();
	}

	moveHeaderContent() {
		const navContainer = this.element.parentNode.querySelector('.v2-nav'); // Avoid sibling order dependence
		if (navContainer) {
			const navRoot = navContainer.querySelector('.v2-nav__root');
			const navTabbed = navContainer.querySelector('.v2-nav__top');
			const navRootHeight =
				window.innerWidth >= 1200 &&
				navRoot &&
				!navContainer.classList.contains('v2-nav--transparent')
					? navRoot.getBoundingClientRect().height
					: 0;
			const navTabbedHeight = navTabbed ? navTabbed.getBoundingClientRect().height : 0;
			// set main tag padding to disclaimer + tabbed nav + nav root height;
			document.querySelector('#main').style.paddingTop =
				this.element.getBoundingClientRect().height + navTabbedHeight + navRootHeight + 'px';
			// Push mega nav by `cookieDisclaimer Height`
			navContainer.style.top = this.element.getBoundingClientRect().height + 'px';
		}
	}

	moveContents() {
		if (this.element.classList.contains('v2-cookie-disclaimer--top')) {
			this.moveHeaderContent();
			pubsub.publish('utility/updateScrollPadding', { isTop: true });
		} else {
			pubsub.publish('utility/updateScrollPadding', { isBottom: true });
		}
		this.publish('cookie/height/change', 'ok');
	}

	show() {
		if (this.element.classList.contains('v2-cookie-disclaimer--extended')) {
			if (this.dom.cookie && getCookie(cookieName)) {
				hideElement(this.dom.cookie);
				!this.element.dataset.extendedMobile && this.showLess();
				this.element.classList.add('v2-cookie-disclaimer--accepted');
			}

			showElement(this.element);
		} else if (!getCookie(cookieName)) {
			showElement(this.element);
		}
		this.moveContents();
	}

	showMore() {
		this.element.classList.add('v2-cookie-disclaimer--extended-show');
		this.element.classList.remove('v2-cookie-disclaimer--short-show');
		this.moveContents();
	}

	showLess() {
		this.element.classList.remove('v2-cookie-disclaimer--extended-show');
		this.element.classList.add('v2-cookie-disclaimer--short-show');
		this.moveContents();
	}
}

export default CookieDisclaimer;
